<script setup>
import { useRouter } from "vue-router";
import { CheckCircleIcon } from "@heroicons/vue/24/solid";

const router = useRouter();

function goToCreateClient() {
  router.go(0);
}
function goToClients() {
  router.push({ name: "DashboardClients" });
}
console.log("Nombre de la ruta actual:", router.currentRoute.value.name);
</script>
<template>
  <div style="background: white">
    <article class="d-flex flex-column justify-content-center gap-3 pt-5">
      <div class="d-flex justify-content-center">
        <CheckCircleIcon class="icon"></CheckCircleIcon>
      </div>
      <div class="d-flex flex-column text-center">
        <h5 class="create-title my-3" style="padding-top: 2rem; color: #243949">
          Cliente registrado exitosamente.
        </h5>
        <p style="color: rgb(125, 143, 152)">
          Puedes continuar registrando clientes o ver los que ya se han
          registrado.
        </p>
      </div>
      <div class="d-flex justify-content-around my-2">
        <button
          class="globals-border-button"
          style="font-weight: 700"
          @click="goToClients"
        >
          Ir a Clientes
        </button>
        <button
          class="globals-button"
          style="font-weight: 700"
          @click="goToCreateClient"
        >
          Registrar Cliente
        </button>
      </div>
    </article>
  </div>
</template>
<style lang="scss" scoped>
@import "@/_scss/global/_variables.scss";
.icon {
  color: $primary-color;
  height: 12rem;
  width: 12rem;
}
</style>
